import { useLocation } from 'react-router';

import { ClientErrorPage } from './ClientErrorPage.tsx';
import { ContactForm } from './contactForm/contactForm.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import { PageErrorBoundary } from '#src/components/PageErrorBoundary/PageErrorBoundary.tsx';

const ContactPage = () => (
  <PageErrorBoundary errorPage={<ClientErrorPage />}>
    <BasePage
      title="Contact Form"
      breadcrumbs={[{ title: 'Docs', href: useLocation().pathname }]}
    >
      <ContactForm />
    </BasePage>
  </PageErrorBoundary>
);

export default () => <ContactPage />;
